export default function aboutIgniteReducer(state = {
    aboutIgniteArticles: [],
    fetching: false,
    fetched: false
  }, action) {
    switch (action.type) {
      case 'GET_ARTICLES_ABOUT_IGNITE_PENDING': {
        return {
          ...state,
          fetching: true,
          fetched: false
        }
      }
      case 'GET_ARTICLES_ABOUT_IGNITE_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          aboutIgniteArticles: action.payLoad
        }
      }
      case 'GET_ARTICLES_ABOUT_IGNITE_REJECTED': {
        return {
          ...state,
          errors: action.payLoad.errors
        }
      }
      default:
    }
  
    return {...state};
  }


// WEBPACK FOOTER //
// ./src/reducers/aboutIgniteReducer.js